module.exports = __webpack_public_path__ + "static/media/education.ceb607b0.webp";